export default __webpack_public_path__ + "static/media/section3_bg4.439566b1.png";